import { Box, Typography } from '@mui/material'
import { CollectingCompanyTableItem } from '../interfaces'
import { Autocomplete, Input } from '@fullscreendigital/carrefour-dex-fe'
import s from './CollectingCompanies.modules.scss'
import { ShopIcon } from 'icons'
import { MultivalueCell } from 'components/core-ui/MultivalueCell'
import { DescriptionText } from 'components/core-ui/DescriptionText'

export const getColumns = (selectRow: (rowId: number, type: string) => void) => [
  {
    title: 'Nume',
    field: 'name',
    align: 'left',
    type: 'string',
    width: '150px'
  },
  {
    title: 'Categorii deseuri',
    field: 'categories',
    align: 'left',
    type: 'string',
    disableSorting: true,
    width: '200px',
    render: (rowData: CollectingCompanyTableItem) => (
      <MultivalueCell value={rowData.categories} field="name" size={1} />
    )
  },
  {
    title: 'Email',
    field: 'email',
    align: 'left',
    type: 'string',
    width: '150px',
    collapsible: true
  },
  {
    title: 'Nr. contact',
    field: 'contactNumber',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Nr. contract',
    field: 'contractNumber',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'Nr. Registru Comert',
    field: 'tradeRegisterNumber',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'CIF',
    field: 'cif',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Sediul',
    field: 'headquarter',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true,
    width: '150px',
    render: (rowData: CollectingCompanyTableItem) => (
      <DescriptionText value={rowData.headquarter} maxWidth={140} />
    )
  },
  {
    title: 'Judet',
    field: 'county',
    align: 'left',
    type: 'string',
    collapsible: true
  },
  {
    title: 'IBAN',
    field: 'iban',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Banca',
    field: 'bank',
    align: 'left',
    type: 'string',
    collapsible: true,
    disableSorting: true
  },
  {
    title: 'Locatii',
    field: 'locationNumber',
    align: 'left',
    type: 'number',
    collapsible: true,
    disableSorting: true,
    render: (rowData: CollectingCompanyTableItem) => (
      <Box
        className={s.locationsNumberContainer}
        onClick={() => selectRow(rowData.id, 'viewLocations')}
      >
        <ShopIcon />
        <Typography component="span">{rowData.locationNumber || 0}</Typography>
      </Box>
    )
  }
]

export const getFilters = (categoryOptions: AutocompleteOption[]) => [
  {
    name: 'name',
    label: 'Nume',
    type: 'text',
    filter: <Input type="text" name="name" label="Nume" variant="outlined" value="" />
  },
  {
    name: 'categories',
    value: undefined,
    filter: (
      <Autocomplete
        variant="outlined"
        label="Categorii deseuri"
        options={categoryOptions || []}
        multiple
      />
    ),
    type: 'autocomplete',
    label: 'Categorii deseuri'
  },
  {
    name: 'contractNumber',
    label: 'Nr. contract',
    type: 'text',
    filter: (
      <Input type="text" name="contractNumber" label="Nr. contract" variant="outlined" value="" />
    )
  }
]
